import React, { Fragment } from 'react';

import InsulinDistributionSVG from './InsulinDistributionSVG';
import Stats from './Stats';
import './Dashboard.css';


function InsulinDistribution(props) {
  const {
    dailyDeviations,
    dailyMeans,
    t,
  } = props;

  return (
    <Fragment>
    <Stats id="insulinDistribution" className="overview">
      <h2>{t('insulin.distribution.heading')}</h2>
      <InsulinDistributionSVG dailyDeviations={dailyDeviations} dailyMeans={dailyMeans} t={t} />
    </Stats>
    <div className="clear"></div>
    </Fragment>
  );
}

export default InsulinDistribution;
